import { useRef } from 'react';
import { GlobalBannerView } from '@frontend/global-info-banner';
import { useTranslation } from '@frontend/i18n';
import { useSettingsNavigate } from '@frontend/settings-routing';
import { useOnboardingFlowInfo } from '../../../hooks/onboarding-flow-hooks/use-onboarding-flow-info';
import { useCheckIsAutoMessagesEnabled } from '../../../hooks/use-check-is-auto-messages-enabled';
import { trackOnboardingFlow } from '../../../utils/track-onboarding-flow';

export const OnboardingFlowAutoMessagesBanner = () => {
  const { t } = useTranslation('schedule-onboarding');

  const { setOnboardingFlowInfo, setShowOnNextLogin, shouldShowAutoMessagesBanner, onboardingFlowInfo } =
    useOnboardingFlowInfo();
  const { navigate } = useSettingsNavigate();
  const { isAutoMessagesEnabled } = useCheckIsAutoMessagesEnabled();
  const isCompletedApptCreationRef = useRef(onboardingFlowInfo.status === 'completed_appointment_creation');

  const handleSetUpNow = () => {
    if (isAutoMessagesEnabled) {
      navigate({ to: '/messaging/auto-messages' });
      trackOnboardingFlow('autoMessagedActivated');
    } else {
      navigate({ to: '/subscriptions/manage-subscription' });
      trackOnboardingFlow('upgradeToAutoMessages');
    }
    setOnboardingFlowInfo({ status: 'completed' });
  };

  if (!isCompletedApptCreationRef.current || !shouldShowAutoMessagesBanner) return null;

  return (
    <GlobalBannerView
      type='info'
      title={t('Stop playing phone tag to confirm appointments')}
      message={t('Set up automated reminders, confirmations, and follow-ups in under 5 minutes')}
      isDismissible
      onDismiss={setShowOnNextLogin}
      action={{
        label: isAutoMessagesEnabled ? t('Set up now') : t('Upgrade Now'),
        onClick: handleSetUpNow,
      }}
    />
  );
};
